import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {CopyToClipboardState} from './types';
import css from './index.inline.styl';
import {template} from './template';

export class CopyToClipboard extends Component<CopyToClipboardState> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      value: {
        description: `The value to be copied`,
        type: `string`,
      },
      label: {
        description: `The label to be displayed on top of the input`,
        type: `string`,
        default: ``,
      },
    };
  }

  get config() {
    return {
      useShadowDom: true,
      template,
      css,
      defaultState: {
        copyElement: null,
        isCopied: false,
      },
      helpers: {
        handleInsert: (copyEl: HTMLInputElement) => {
          this.update({copyElement: copyEl});
        },
      },
    };
  }
}

export const CopyToClipboardEl = defineAndMakeJsxFactory(`mp-copy-to-clipboard`, CopyToClipboard);
export const CopyToClipboardReact = panel2react(`mp-copy-to-clipboard`, CopyToClipboard);
